import * as types from 'store/types';
import services from 'services/services';

import moment from 'moment';

// Import variables
import {
	LOCALSTORAGE_USER,
	LOCALSTORAGE_LNG,
	AUTH_API_URL,
	REGISTER_API_URL,
	AUTH_LOGOUT_API_URL,
	RESEND_CODE_API_URL,
	RESEND_CALL_API_URL,
	VERIFY_API_URL,
	FORGET_PASSWORD_SEND_CODE_URL,
	CHANGE_PASSWORD,
} from 'helpers';
import { getAuthData } from './helpers';

const completeLogin = (data, dispatch) => {
	// Convert data
	const { authData, authLocalStorage } = getAuthData(data);

	// Add to Local storage
	localStorage.setItem(LOCALSTORAGE_USER, JSON.stringify(authLocalStorage));

	dispatch({
		type: types.AUTH_USER_SUCCESS,
		payload: authData,
	});
};

// ******************** SIGN IN ********************
export const signIn = (values, errorCallback) => async (dispatch) => {
	try {
		// Get response

		const { data } = await services.post(AUTH_API_URL, values);
		if (data.token !== undefined && data.user_id !== undefined) {
			errorCallback({
				...data,
				type: 'verification',
			});
		} else {
			completeLogin(data, dispatch);
		}
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
		dispatch({
			type: types.AUTH_USER_ERROR,
			payload: true,
		});
	}
};

export const setUserProfile = (data) => {
	return {
		type: types.AUTH_USER_PROFILE_SUCCESS,
		payload: data,
	};
};

export const signUp = (values, errorCallback, successCallback) => async (
	dispatch
) => {
	let phoneNumber = values.phone;
	if (phoneNumber.startsWith('0')) {
		phoneNumber = phoneNumber.substring(1);
	}

	try {
		const params = {
			name: values.name,
			email: values.email,
			birth_date: moment(values.birth_date).format('DD/MM/YYYY'),
			country_code: values.country_code,
			phone: phoneNumber,
			password: values.password,
			legal_age: values.legal_age ? 1 : 0,
			'document-type': 'none',
			license_number: values.id_number,
			license_expire_date: moment(values.license_expire_date).format(
				'DD/MM/YYYY'
			),
		};
		const {
			data: {
				data: {
					customer: { uuid },
					system: {
						is_supporting_sms: isSupportingSms,
						is_supporting_call: isSupportingCall,
					},
					token,
				},
			},
		} = await services.post(REGISTER_API_URL, params);
		successCallback(uuid, token, isSupportingSms, isSupportingCall);
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
	}
};

export const resendCode = async (userId, errorCallback, successCallback) => {
	try {
		const {
			data: {
				data: { token },
			},
		} = await services.post(RESEND_CODE_API_URL(userId));
		successCallback(token);
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
	}
};

export const resendCall = async (userId, errorCallback, successCallback) => {
	try {
		const {
			data: {
				data: { token },
			},
		} = await services.post(RESEND_CALL_API_URL(userId));
		successCallback(token);
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
	}
};

export const sendCode = async (values, errorCallback, successCallback) => {
	try {
		const {
			data: { message },
		} = await services.post(FORGET_PASSWORD_SEND_CODE_URL, {
			phone: values.country_code + values.phone,
		});
		// TODO message = "Password reset code sent"
		successCallback(message);
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
	}

	// TODO
	// SignInForm
	// const handleSubmit = async (values) => {
	// 	let apiErrors = {};
	// 	await sendCode(values, (errors) => {
	// 		apiErrors = convertApiFormErrors(errors);
	// 	}, (message) => {
	// 		// TODO message = "Password reset code sent"
	// 	});
	// 	return apiErrors;
	// };
};

export const changePassword = async (
	values,
	errorCallback,
	successCallback
) => {
	try {
		const { data } = await services.post(CHANGE_PASSWORD, {
			code: values.code,
			phone: values.country_code + values.phone,
			password: values.password,
			password_confirmation: values.password_confirmation,
		});
		successCallback(data);
	} catch (error) {
		error.response &&
			errorCallback(error.response.data.errors || error.response.data.error);
	}

	// TODO
	// SignUpForm
	// const handleSubmit = async (values) => {
	// 	let apiErrors = {};
	// 	values.code = '0000'
	// 	await changePassword(values, (errors) => {
	// 		apiErrors = convertApiFormErrors(errors);
	// 	}, (data) =>{
	// 		history.push(APP_PATHS.SIGN_IN)
	// 	});
	// 	return apiErrors;
	// };
};

export const verify = (values, errorCallback) => async (dispatch) => {
	try {
		const {
			data: { data },
		} = await services.post(VERIFY_API_URL(values.id), values);
		completeLogin(data, dispatch);
	} catch (error) {
		error.response && errorCallback(error.response.data.errors);
	}
};

// ******************** SIGN OUT ********************
const removeLocalStorageUser = () => {
	localStorage.removeItem(LOCALSTORAGE_USER);
	localStorage.removeItem(LOCALSTORAGE_LNG);
};

export const signOut = () => async (dispatch) => {
	setTimeout(() => {
		// Remove user data from local storage even if network request failed
		removeLocalStorageUser();
	}, 5000);

	try {
		// Dispatch an loading action
		dispatch({
			type: types.AUTH_SIGN_OUT_LOADING,
			payload: true,
		});
		// Sign out user from application
		await services.get(AUTH_LOGOUT_API_URL);

		// Remove user data from local storage
		removeLocalStorageUser();

		dispatch({
			type: types.AUTH_SIGN_OUT_SUCCESS,
			payload: true,
		});
	} catch (error) {
		dispatch({
			type: types.AUTH_SIGN_OUT_ERROR,
			payload: true,
		});
	}
};

// ******************** SIGN OUT ********************
export const signNotAuthOut = (authenticate) => async (dispatch) => {
	// Remove user data from local storage
	localStorage.removeItem(LOCALSTORAGE_USER);

	authenticate &&
		dispatch({
			type: types.AUTH_SIGN_OUT_SUCCESS,
			payload: true,
		});
};
